import { UIComponentViewImpl } from '../../../../toolkit/uicomponentview';

import { UIDataModel } from '../../../../toolkit/uicomponent';

import { ForgotPasswordOTPMessageComponentProps, ForgotPasswordOTPMessageComponentHandler, ForgotPasswordOTPMessageComponentState } from './forgotpasswordotpmessagecomponent';

import { ForgotPasswordOTPMessageCSSStyle } from './forgotpasswordotpmessagecss';

import * as React from 'react';

import { Strings } from '../../../../../utils/resources/strings';


import { ConfirmRequestConfirmButtonCSSStyleImpl } from '../../../popup/confirmrequest/confirmrequestconfirmbuttoncss';
import { ButtonComponent } from '../../../../toolkit/button/buttoncomponent';

import { MessageComponent } from '../../../../toolkit/messagecomponent/messagecomponent';
import { ForgotPasswordDto, ForgotPasswordDtoImpl } from '../../../../../core/dto/forgotpassword/forgotpassworddto';
import { ConfirmationComponent } from '../../confirmation/confirmationcomponent';
import { FloatingTextComponent } from '../../../../toolkit/floatingtext/floatingtextcomponent';
import { AlertComponent } from '../../../../toolkit/alert/alertcomponent';
import { AlertType } from '../../../../toolkit/alert/alerttype';
import { PopUpWrapperComponent } from '../../../popup/popupwrappercomponent';
import { LoaderComponent } from '../../../../toolkit/loader/loadercomponent';
import { LoaderWrapperComponent } from '../../../popup/loaderwrappercomponent';

import './forgot-password-otp-style.css';

export class ForgotPasswordOTPMessageViewImpl extends UIComponentViewImpl<UIDataModel>
{
     numberComponent: any;
     otp: any;
     passwordComponent1: any;
     passwordComponent2 : any;
   
     private popUpComponent: PopUpWrapperComponent;
     private loaderWrapperComponent:LoaderWrapperComponent;

   

  
    bindHandlers()
    {
        this.onCloseButtonClick  = this.onCloseButtonClick.bind(this);
        this.onResetPasswordClick = this.onResetPasswordClick.bind(this);
        this.onResendOtpClick = this.onResendOtpClick.bind(this);
        this.onLoginClick = this.onLoginClick.bind(this);
        this.closePopup = this.closePopup.bind(this);
        this.showPopup = this.showPopup.bind(this);
        this.showLoader = this.showLoader.bind(this);
        this.dismissLoader = this.dismissLoader.bind(this);
        this.onLogoClicked = this.onLogoClicked.bind(this);
    }
 
    draw(props: ForgotPasswordOTPMessageComponentProps, state: ForgotPasswordOTPMessageComponentState, cssStyle: ForgotPasswordOTPMessageCSSStyle): JSX.Element | boolean
    {
        super.draw(props, state, cssStyle);

     
        if(state.isResetPasswordSuccess)
        {
            return <ConfirmationComponent context={props.context} message={props.context.getResources().getString(Strings.change_password_message)} onClick={this.onLoginClick}/>;
        }
        else
        {
        return (
            <div id="forgot-password-otp-wrapper" style={cssStyle.getWrapperCSSStyle()}>
                <div style={cssStyle.getInnerWrapperCSSStyle()}>
                {/* <img onClick={this.onLogoClicked} style={{cursor: "pointer",width:'100%',height:"80px",marginBottom:'45px',marginTop:'0px',marginLeft:'-135px'}} src={props.context.getResources().getImage("mpt_logo.svg")}  /> */}
                <img id="forgot-password-otp-logo" onClick={this.onLogoClicked} style={{cursor: "pointer",width:'auto',height:"80px",marginBottom:'45px',marginTop:'0px'}} src={props.context.getResources().getImage("mpt_logo.svg")}  />
                <label id="forgot-password-otp-heading" style={cssStyle.getTitleCSSStyle()}>{props.context.getResources().getString(Strings.enterotp)}</label>
                   
                    { state.isOTPMessageShow &&
                  <div id="forgot-password-otp-page-message-wrapper" style={cssStyle.getMessageCSSStyle()}>
                       <MessageComponent onCloseButtonClicked={this.onCloseButtonClick} messageContent={props.context.getResources().getString(Strings.otp_message)}  context={props.context} />
                   </div>
                  }
                    <div style={cssStyle.getMobileNumberCSSStyle()}>
                        <FloatingTextComponent hint={this.getContext().getResources().getString(Strings.otphint)} maxLength={this.getUIProps().context.getResources().getString(Strings.otp_max_length)} ref={(item: any) => this.numberComponent = item} id={"#otp"} value={""} inputType={"number"} isRequired={true} placeholder={props.context.getResources().getString(Strings.enterotp)} context={props.context} emptyErrorMsg={props.context.getResources().getString(Strings.incorrectotp)}/>
                    </div>
                    <div style={cssStyle.getMobileNumberCSSStyle()}>
                    <FloatingTextComponent hint={this.getContext().getResources().getString(Strings.password)} maxLength={this.getUIProps().context.getResources().getString(Strings.passwordMaxLength)} ref={(item: any) => this.passwordComponent1 = item} id={"#password"} value={""} inputType={"password"} isRequired={true} placeholder={props.context.getResources().getString(Strings.password)} context={props.context} emptyErrorMsg={props.context.getResources().getString(Strings.passwordIncorrect)}/>
                    </div>
                    <div style={cssStyle.getMobileNumberCSSStyle()}>
                    <FloatingTextComponent hint={this.getContext().getResources().getString(Strings.password)} maxLength={this.getUIProps().context.getResources().getString(Strings.passwordMaxLength)} ref={(item: any) => this.passwordComponent2 = item} id={"#confirmPassword"} value={""} inputType={"password"} isRequired={true} placeholder={props.context.getResources().getString(Strings.confirm_password)} context={props.context} emptyErrorMsg={props.context.getResources().getString(Strings.passwordIncorrect)}/>
                    </div>
                    <div style={cssStyle.getRequestOTPButtonCSSStyle()}>
                        <ButtonComponent onClick={this.onResetPasswordClick}  style={new ConfirmRequestConfirmButtonCSSStyleImpl(props.context)}  context={props.context} label={props.context.getResources().getString(Strings.verify)}/>
                    </div>
                    <br/>
                    <div style={cssStyle.getSignUpRowDivCSSStyle()}>
                        
                        <label style={cssStyle.getDoUHaveAccountCSSStyle()}>{props.context.getResources().getString(Strings.didntreceivecode)}</label>
                        <label onClick={this.onResendOtpClick} style={cssStyle.getResendButtonCSSStyle(state.isResendButtonRestricted)}>{props.context.getResources().getString(Strings.resendotp)}</label>
                       
                        <div id="countdown"style={{display:'flex',fontSize:'14px'}}/>
                
                        
                    </div>
                </div>
                <LoaderWrapperComponent ref={(item: any) => this.loaderWrapperComponent = item} context={props.context}/>
                <PopUpWrapperComponent ref={(item: any) => this.popUpComponent = item} context={props.context}/>
            </div>
        );
                }
    }

    validateData(): void
    {
        var passwordReg = new RegExp(this.getUIProps().context.getResources().getString(Strings.regular_expression));

       

        if(this.numberComponent.validate() && this.passwordComponent1.validate() && this.passwordComponent2.validate())
        {
            let numberLength = +this.getUIProps().context.getResources().getString(Strings.otp_max_length);
            let passwordMinLength = +this.getUIProps().context.getResources().getString(Strings.passwordMinLength);
            let passwordmaxLength = +this.getUIProps().context.getResources().getString(Strings.passwordMaxLength);
    

            if(this.numberComponent.getData().length !== numberLength)
            {
                this.numberComponent.setErrorMessage(this.getUIProps().context.getResources().getString(Strings.incorrectotp));
                
            }
            else if(this.passwordComponent1.getData().length < passwordMinLength 
            || this.passwordComponent1.getData().length > passwordmaxLength)
          {
           console.log("p1 validation");
           this.passwordComponent1.setErrorMessage(this.getUIProps().context.getResources().getString(Strings.invalidLength));
   
          }
else if(!passwordReg.test(this.passwordComponent1.getData()))
{
    console.log("p1 regex validation"+this.passwordComponent1.getData());
    this.passwordComponent1.setErrorMessage(this.getUIProps().context.getResources().getString(Strings.incorrectpasswordpolicy));
 
}

 else if(this.passwordComponent2.getData().length < passwordMinLength 
            || this.passwordComponent2.getData().length > passwordmaxLength)
{
    console.log("p2 validation");
    this.passwordComponent2.setErrorMessage(this.getUIProps().context.getResources().getString(Strings.invalidLength));
 
}
else if(!passwordReg.test(this.passwordComponent2.getData()))
{
    console.log("p2 regex validation");
    this.passwordComponent2.setErrorMessage(this.getUIProps().context.getResources().getString(Strings.incorrectpasswordpolicy));
  
}
else if(this.passwordComponent1.getData() !== this.passwordComponent2.getData())
{
    console.log("comparison validation");
    this.passwordComponent2.setErrorMessage(this.getUIProps().context.getResources().getString(Strings.confirmedpasswordmismatch));
   
}
else
{
//     console.log("sign up");
    (this.getUIComponentHandler() as ForgotPasswordOTPMessageComponentHandler).onResetPassword();
}
   
}
     
}

    getData(): ForgotPasswordDto
    {
        let request = new ForgotPasswordDtoImpl();
        request.setOTP(this.numberComponent.getData());
        // request.setMsisdn(this.numberComponent.getData());
        request.setPassword(this.passwordComponent2.getData());

        return request;
    }
    protected onLogoClicked()
    {
        (this.getUIComponentHandler() as ForgotPasswordOTPMessageComponentHandler).onLogoClicked();
    }
    showLoader()
    {
       
        this.loaderWrapperComponent !== null && this.loaderWrapperComponent.setShowWindow(true,  <LoaderComponent context={this.getUIProps().context}/>);   
    }
  
    dismissLoader()
    { 
        this.loaderWrapperComponent !== null && this.loaderWrapperComponent.setShowWindow(false, <></>);
    }
    closePopup()
    {
        this.popUpComponent !== null && this.popUpComponent.setShowWindow(false, <></>);
    }

    showPopup(id:string,msg:string,type:AlertType):void
    {
      
        this.popUpComponent !== null && this.popUpComponent.setShowWindow(true, <AlertComponent buttonTitle={this.getContext().getResources().getString(Strings.ok)} alertMessage={msg} alertType={type} onCloseButtonClick={this.closePopup} onClick={this.closePopup} context={this.getUIProps().context}/>);

    }
    private onResetPasswordClick():void
    {
        (this.getUIComponentHandler() as ForgotPasswordOTPMessageComponentHandler).onResetPasswordButtonClicked();
    }

    private onResendOtpClick():void
    {
        (this.getUIComponentHandler() as ForgotPasswordOTPMessageComponentHandler).onResendOtpButtonClicked();
    }

    private onCloseButtonClick():void
    {
        (this.getUIComponentHandler() as ForgotPasswordOTPMessageComponentHandler).onCloseButtonClicked();
    }

    private onLoginClick():void
    {
        (this.getUIComponentHandler() as ForgotPasswordOTPMessageComponentHandler).onLoginButtonClicked();    
    }

    
  
}


// WEBPACK FOOTER //
// ./src/com/sixdee/crbtportal/ui/components/login/forgotpasswordotp/forgotpasswordotpmessage/forgotpasswordotpmessageview.tsx